<template>
    <div class="flex-center flex-right setting">
        <span><img class="block" :src="IconSource()" :alt="`Icon - ${setting.type}`" :title="setting.type" width="40" height="40"/></span>
        <span class="setting-type"><b>{{ setting.type }}</b></span>
        <span class="flex">
            <div class="flex-center margin-l" v-for="(value, v) in setting.values" :key="v">
                <span>{{ value }}</span>
                <img class="btn" :src="RadioSource(value)" :alt="`${value}`" :title="`${value}`" width="25" height="25" @click="Toggle(value)"/>
            </div>
        </span>
    </div>
</template>

<script>
import { ASSETS } from "@/assets/JS/Assets.js";
import store from "@/store";

export default {
    name: "Setting",
    props: { setting: Object },
    data: () => ({ projectViewType: {} }),
    methods: {
        Toggle: function(view) {
            const projectViewType = {
                view,
                show: true
            };
            store.state.settings.projectViewType = projectViewType;
            ASSETS.SetStorage("Portfolio", store.state);
            this.$emit("select", {
                setting: this.setting,
                selected: projectViewType
            });
            this.projectViewType.view = view;
        },
        RadioSource: function(value) {
            let source = this.projectViewType.view === value
                ? "RadioButtonActive.png"
                : "RadioButtonInactive.png";
            return require(`@/assets/Images/${source}`);
        },
        IconSource: function() {
            switch(this.setting.type) {
                case "View":
                    return require("@/assets/Images/Settings/IconProjectsView.png");
            }
        }
    },
    beforeMount: function() {
        let portfolio = ASSETS.GetStorage("Portfolio");
        if (!portfolio) {
            this.projectViewType.view = "";
        } else {
            switch(this.setting.type) {
                case "View":
                    this.projectViewType = portfolio.settings.projectViewType;
                    break;
            }
        }
    },
    emits: [ "select" ]
};
</script>